'use client';

import { createContext } from 'react';

import type { DrawerFloatingContextInterface } from '../types/use-drawer.types';

export const DrawerFloatingContext = createContext({} as DrawerFloatingContextInterface);

DrawerFloatingContext.displayName = 'Drawer.Floating.Context';
